module.exports = __webpack_public_path__ + "static/contentsquare-db2b9b1692220c930ddb9b730cb1be20.png";